export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function truncateText(value: string, maxLength: number = 50): string {
  if (!value || value.length <= maxLength) return value;
  return `${value.slice(0, maxLength).trimEnd()}...`;
}

export function displayValue(
  value: string | number | null | undefined,
  fallback: string = "-"
): string {
  if (value === null || value === undefined) return fallback;
  const stringValue = typeof value === "string" ? value : String(value);
  return stringValue.trim() === "" ? fallback : stringValue;
}
